export var Kind;

(function (Kind) {
  Kind[Kind["Global"] = 0] = "Global";
  Kind[Kind["ExternalModule"] = 1] = "ExternalModule";
  Kind[Kind["Module"] = 2] = "Module";
  Kind[Kind["Enum"] = 4] = "Enum";
  Kind[Kind["EnumMember"] = 16] = "EnumMember";
  Kind[Kind["Variable"] = 32] = "Variable";
  Kind[Kind["Function"] = 64] = "Function";
  Kind[Kind["Class"] = 128] = "Class";
  Kind[Kind["Interface"] = 256] = "Interface";
  Kind[Kind["Constructor"] = 512] = "Constructor";
  Kind[Kind["Property"] = 1024] = "Property";
  Kind[Kind["Method"] = 2048] = "Method";
  Kind[Kind["CallSignature"] = 4096] = "CallSignature";
  Kind[Kind["IndexSignature"] = 8192] = "IndexSignature";
  Kind[Kind["ConstructorSignature"] = 16384] = "ConstructorSignature";
  Kind[Kind["Parameter"] = 32768] = "Parameter";
  Kind[Kind["TypeLiteral"] = 65536] = "TypeLiteral";
  Kind[Kind["TypeParameter"] = 131072] = "TypeParameter";
  Kind[Kind["Accessor"] = 262144] = "Accessor";
  Kind[Kind["GetSignature"] = 524288] = "GetSignature";
  Kind[Kind["SetSignature"] = 1048576] = "SetSignature";
  Kind[Kind["ObjectLiteral"] = 2097152] = "ObjectLiteral";
  Kind[Kind["TypeAlias"] = 4194304] = "TypeAlias";
  Kind[Kind["Event"] = 8388608] = "Event";
  Kind[Kind["Reference"] = 16777216] = "Reference";
  Kind[Kind["ClassOrInterface"] = 384] = "ClassOrInterface";
  Kind[Kind["VariableOrProperty"] = 1056] = "VariableOrProperty";
  Kind[Kind["FunctionOrMethod"] = 2112] = "FunctionOrMethod";
  Kind[Kind["ClassMember"] = 8654336] = "ClassMember";
  Kind[Kind["SomeSignature"] = 1601536] = "SomeSignature";
  Kind[Kind["SomeModule"] = 3] = "SomeModule";
  Kind[Kind["SomeType"] = 4391168] = "SomeType";
  Kind[Kind["SomeValue"] = 2097248] = "SomeValue";
})(Kind || (Kind = {}));